import { defineMessages } from 'react-intl';

/**
 * Shared copy for the greyed-out treatment on connectivity-dependent
 * controls (Create/generate, Evidence chat composer, note editing) while the app
 * is offline, so the clinician understands *why* something is unavailable.
 *
 * `notAvailableOffline` now appears in three forms: a hover tooltip on a
 * disabled control, a disabled row standing in for a gated command section, and
 * centred body copy in a gated picker's empty state. Its `description` still
 * says "tooltip", and deliberately so — `formatjs/enforce-id` hashes the id
 * over defaultMessage AND description, so rewording the description re-keys the
 * string and orphans every existing translation of it. Widening it is a
 * deliberate retranslation of a ~27-call-site string, not a comment tidy-up.
 */
export const offlineGatingMessages = defineMessages({
  notAvailableOffline: {
    defaultMessage: 'Not available offline',
    id: 'YUQP53BBqM',
    description:
      'Tooltip shown when hovering a control that is disabled because the app is offline',
  },
  availableOnceSynced: {
    defaultMessage: 'Available once this session has synced',
    id: 'PoXBvj8aEM',
    description:
      'Shown on a picker choice that cannot be used yet because the session audio is waiting to sync',
  },
  syncInFlightTitle: {
    defaultMessage: 'This session is uploading',
    id: 'h2/r6bIbKp',
    description:
      'Tooltip title on the disabled Resume control for an offline session whose recordings are being uploaded',
  },
  syncInFlightDescription: {
    defaultMessage: 'You can record more once the upload finishes.',
    id: 'WluP366ulC',
    description:
      'Tooltip body on the disabled Resume control for an offline session whose recordings are being uploaded, telling the clinician the wait is temporary',
  },
});
